/**
 * Pasa por los productos del portal, al encontrar el solicitado, busca la categoría
 * asociada y la devuelve, false si no la encuentra.
 * @param Object portal
 * @param Number id_curso
 */
function getCategoriaDeProducto(portal, id_curso) {
    let categoria;
    portal.productos_portal.forEach(
        producto => {
            producto.productos_categorias.forEach(cat => {
                if (cat.id_producto == id_curso) {
                    categoria = portal.categorias.filter(
                        c => c.id == cat.id_categoria
                    )[0];
                }
            });
        }
    );
    if (categoria) return categoria;
    else return false;
}



/**
 * Pasa por los productos del portal, al encontrar el solicitado, busca la categoría
 * asociada solo si tiene destacado footer activo y la devuelve, false si no la encuentra.
*/
function getProductoDeCategoriaFooter(portal, id_curso) {
    let categoria;
    portal.productos_portal.forEach(
        producto => {
            producto.productos_categorias.forEach(cat => {
                if (cat.id_producto == id_curso) {
                    categoria = portal.categorias.filter(
                        c => c.id == cat.id_categoria
                    )[0];
                }
            });
        }
    );
    if (categoria) return categoria;
    else return false;
}


/**
 * Pasa por los productos del portal, luego por sus categorías y si
 * tiene la categoría asociada, lo devuelve.
 * @param Object portal
 * @param Number id_categoria
 */
function getProductoDeCategoria(portal, id_categoria) {
    let selectedProducto = false;
    portal.productos_portal.forEach(
        producto => {
            producto.productos_categorias.forEach(cat => {
                if (cat.id_categoria == id_categoria && selectedProducto === false) selectedProducto = producto
            });
        }
    );
    return selectedProducto
}




/**
 * Pasa por los productos del portal, solo si tiene allaccess
 * tiene allaccess asociada, lo devuelve.
 * @param Object portal
 */
function getAllAccessDeProducto(portal) {
    let selectedAllAccess = false;
    portal.productos_portal.forEach(
        producto => {
            if (producto.productos_accesos.length >= 0) {
                producto.productos_accesos.forEach(cat => {
                    if (cat.tipo_portal == 1 && selectedAllAccess === false) selectedAllAccess = producto
                });
            }
        }
    );
    return selectedAllAccess
}

/**
 * Pasa por los productos del portal
 * @param Object portal
 */
function getProducto(portal, id_producto) {
    let selectedProducto = false;
    portal.productos_portal.forEach(
        producto => {
            if (producto.id == id_producto && selectedProducto === false) selectedProducto = producto
        }
    );
    return selectedProducto
}

/**
 * Devuelve el video que le sigue al especificado en la categoría especificada.
 * @param categoria
 * @param id_video
 */
function getNextVideo(categoria, id_video) {
    if (typeof categoria !== 'object') return false
    if (categoria.id == 0) return false

    // El portal tiene contenidos
    if (typeof categoria.contenidos !== 'object') return false
    if (categoria.contenidos.length == 0) return false

    // Ordenar contenidos por posicion y buscar video actual
    let foundCurrent = false
    let nextVideo = false
    categoria.contenidos
        .forEach(contenido => {
            // Ordenar videos de contenido por posición y buscar actual.
            contenido.contenidos_videos
                .forEach(video => {
                    // Ya había encontrado el actual, este es el siguiente, devolver.
                    if (foundCurrent == true && !nextVideo) {
                        nextVideo = video

                    }
                    // Actual
                    if (video.id == id_video) {
                        foundCurrent = true
                    }
                })
        })

    // No hay más
    return nextVideo

}
/**
 * Devuelve el video que le sigue al especificado en la categoría especificada.
 * @param categoria
 * @param id_video
 */
function getNextContenido(categoria, id_video) {
    if (typeof categoria !== 'object') return false
    if (categoria.id == 0) return false

    // El portal tiene contenidos
    if (typeof categoria.contenidos !== 'object') return false
    if (categoria.contenidos.length == 0) return false

    // Ordenar contenidos por posicion y buscar video actual
    let foundCurrent = false
    let nextVideo = false
    categoria.contenidos
        .forEach(contenido => {
            // Ordenar videos de contenido por posición y buscar actual.
            contenido.contenidos_videos
                .forEach(video => {
                    // Ya había encontrado el actual, este es el siguiente, devolver.
                    if (foundCurrent == true && !nextVideo) {
                        nextVideo = contenido

                    }
                    // Actual
                    if (video.id == id_video) {
                        foundCurrent = true
                    }
                })
        })

    // No hay más
    return nextVideo

}

/**
 * Devuelve el video que le precede al especificado en la categoría especificada.
 * @param Object portal
 * @param Number id_video
 */
function getPreviousVideo(categoria, id_video) {
    console.log('start cat', categoria, 'video', id_video)
    if (typeof categoria !== 'object') return false
    if (categoria.id == 0) return false

    // El portal tiene contenidos
    if (typeof categoria.contenidos !== 'object') return false
    if (categoria.length == 0) return false

    // Ordenar contenidos por posicion y buscar video actual
    let last = false
    let found = false
    categoria.contenidos
        .forEach(contenido => {
            // Ordenar videos de contenido por posición y buscar actual.
            contenido.contenidos_videos
                .forEach(video => {
                    // Actual
                    if (video.id == id_video && !found) {
                        // Si hay uno anterior, dejamos de buscar
                        found = true
                        console.log('found ' + video.id, 'last actual',
                            last
                        )
                    }
                    if (!found) {
                        // Guardar y seguir buscando.
                        last = { ...video
                        }
                        console.log('asignando last', last)
                    }
                })
        })
    // No hay más
    return last
}
/**
 * Devuelve el video que le precede al especificado en la categoría especificada.
 * @param Object portal
 * @param Number id_video
 */
function getPreviousContenido(categoria, id_video) {
    console.log('start cat', categoria, 'video', id_video)
    if (typeof categoria !== 'object') return false
    if (categoria.id == 0) return false

    // El portal tiene contenidos
    if (typeof categoria.contenidos !== 'object') return false
    if (categoria.length == 0) return false

    // Ordenar contenidos por posicion y buscar video actual
    let last = false
    let found = false
    categoria.contenidos
        .forEach(contenido => {
            // Ordenar videos de contenido por posición y buscar actual.
            contenido.contenidos_videos
                .forEach(video => {
                    // Actual
                    if (video.id == id_video && !found) {
                        // Si hay uno anterior, dejamos de buscar
                        found = true
                        console.log('found ' + video.id, 'last actual',
                            last
                        )
                    }
                    if (!found) {
                        // Guardar y seguir buscando.
                        last = { ...contenido
                        }
                        console.log('asignando last', last)
                    }
                })
        })
    // No hay más
    return last
}

/**
 * Revisa si el usuario tiene un producto comprado ó regalado.
 * @param Object user
 * @param Number id_producto
 */
function userTieneProducto(user, id_producto) {
    let tiene = false
    let arrCompras = ['mis_compras', 'mis_compras_moviles', 'mis_regalos', 'mis_compras_app']
    arrCompras.forEach(compras => {
        if (user[compras]) {
            user[compras].forEach(compra => {
                if (compra.detalles_compras.compras_productos) {
                    compra.detalles_compras.compras_productos.forEach(producto => {
                        if (producto.id_producto == id_producto) tiene = true
                    })
                }
            })
        }
    })
    return tiene
}





/**
 * Devuelve el texto para la duración del video.
 */
function getDuracionVideo(video) {
    if (parseInt(video.video_duracion)) {
        let flag = false;
        let pos = ["h", "m", "s"];
        if (new Date(video.video_duracion * 1000) == "Invalid Date")
            return "";
        return new Date(video.video_duracion * 1000)
            .toISOString()
            .substr(11, 8)
            .split(":")
            .map((item, i) => {
                if (item != "00" && !flag) flag = true;

                return item == "00" && !flag ?
                    "" :
                    parseInt(item) + pos[i];
            })
            .filter(item => item != "")
            .join(" ");
    }
    return "";
}

function getProgresoVideo(user, id_video) {
    // Primero en videos.
    let inVideos = false;
    let progreso = 0
    user.videos.forEach(video => {
        if ("compras_productos_categoria_video_progreso" in video)
            video.compras_productos_categoria_video_progreso.forEach(
                v => {
                    if (
                        v.id_contenido_video ==
                        id_video &&
                        user.id ==
                        v.id_user
                    ) {
                        progreso = parseInt(v.progreso)
                        //inVideos = true;
                    }
                }
            );
    });
    if (!inVideos) {
        // Pasar por all access.
        if ("all_access" in user) {
            let aavideo = user.all_access.find(
                v => v.id_contenido_video == id_video
            );
            if (aavideo) {
                progreso = parseInt(aavideo.progreso);
            }
        }
    }
    return progreso
}

/**
 * Si el título del video comienza igual al del contenido, quitarselo.
 */
function quitarTituloContenido(contenido, video) {
    return  video.titulo;
}

export {
    getCategoriaDeProducto,
    getProductoDeCategoria,
    getPreviousVideo,
    getNextVideo,
    getAllAccessDeProducto,
    getProducto,
    userTieneProducto,
    getDuracionVideo,
    getProgresoVideo,
    quitarTituloContenido,
    getProductoDeCategoriaFooter,
    getNextContenido,
    getPreviousContenido
}
